import "@arco-design/web-react/es/ConfigProvider/style";
import _ConfigProvider from "@arco-design/web-react/es/ConfigProvider";
import './style/global.less';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import enUS from '@arco-design/web-react/es/locale/en-US';
import { HashRouter, Switch, Route } from 'react-router-dom'; //BrowserRouter 改HashRouter

import rootReducer from './store';
import PageLayout from './layout';
import { GlobalContext } from './context';
import Login from './pages/login';
import checkLogin from './utils/checkLogin';
import changeTheme from './utils/changeTheme';
import useStorage from './utils/useStorage';
// import './mock';  //注释
// import { Get_userInfo } from '@/api/user'; //新增

const store = createStore(rootReducer);
function Index() {
  const [lang, setLang] = useStorage('arco-lang', 'zh-CN');
  const [theme, setTheme] = useStorage('arco-theme', 'dark');
  // const [lang, setLang] = useStorage('arco-lang', 'en-US');
  // const [theme, setTheme] = useStorage('arco-theme', 'light');

  function getArcoLocale() {
    switch (lang) {
      case 'zh-CN':
        return zhCN;
      case 'en-US':
        return enUS;
      default:
        return zhCN;
    }
  }
  function fetchUserInfo() {
    store.dispatch({
      type: 'update-userInfo',
      payload: {
        userLoading: true
      }
    });
    //新增
    // Get_userInfo().then(res => {
    //   store.dispatch({
    //     type: 'update-userInfo',
    //     payload: {
    //       userInfo: res.data,
    //       userLoading: false
    //     }
    //   });
    // });
    //注释
    // axios.get('/api/user/userInfo').then((res) => {
    //   store.dispatch({
    //     type: 'update-userInfo',
    //     payload: { userInfo: res.data, userLoading: false },
    //   });
    // });
  }
  useEffect(() => {
    if (checkLogin()) {
      fetchUserInfo();
    } else if (window.location.hash.replace(/\//g, '') !== 'login') {
      window.location.hash = '/login';
    }
  }, []);
  useEffect(() => {
    changeTheme(theme);
  }, [theme]);
  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme
  };
  return /*#__PURE__*/React.createElement(HashRouter, null, /*#__PURE__*/React.createElement(_ConfigProvider, {
    locale: getArcoLocale(),
    componentConfig: {
      Card: {
        bordered: false
      },
      List: {
        bordered: false
      },
      Table: {
        border: false
      }
    }
  }, /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(GlobalContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/login",
    component: Login
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/",
    component: PageLayout
  }))))));
}
ReactDOM.render(/*#__PURE__*/React.createElement(Index, null), document.getElementById('root'));